import { defineStore } from 'pinia';

export const useFuturesStore = defineStore('futures', {
    state: () => {
        return {
            coin: [],
        };
    },
    actions: {
        setCoin(val) {
            this.coin = val;
        },
    },
});
